import { render, staticRenderFns } from "./CollectionForm.vue?vue&type=template&id=5f355a46"
import script from "./CollectionForm.vue?vue&type=script&lang=js"
export * from "./CollectionForm.vue?vue&type=script&lang=js"
import style0 from "./CollectionForm.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports